// Candidate-details URL (`/candidates/:contactId`) for the underway popup's
// candidate link. The move surfaces hand us different application/contact
// shapes, so look for the contact id in the usual spots. Returns '' when it
// can't be resolved, so callers render a plain (non-linked) pill instead of
// linking to the wrong place.
export const getCandidateProfileUrl = (application: any): string => {
  const contactId =
    application?.contact?.id ?? application?.candidate?.id ?? null;
  return contactId ? `/candidates/${contactId}` : '';
};
